module.exports = __webpack_public_path__ + "static/img/funny_21.03e3fe17.jpg";